import styled, { css } from "styled-components";

export const Container = styled.p`
  ${({ theme, color, type }) => css`
    font-size: ${theme.paragraphs[type].fontSize};
    font-weight: ${theme.paragraphs[type].fontWeight};
    font-family: ${theme.paragraphs[type].fontFamily};
    color: ${theme.colors.dark};
    color: ${color};
    color: ${theme.colors[color]};
    line-height: 1.5;
    text-transform: lowercase;

    :first-letter {
      text-transform: uppercase;
    }

    @media screen and (max-width: 1024px) {
      font-size: ${theme.paragraphs[`${type}Mobile`].fontSize};
      font-weight: ${theme.paragraphs[`${type}Mobile`].fontWeight};
      font-family: ${theme.paragraphs[`${type}Mobile`].fontFamily};
    }
  `}
`;
